var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("编辑"),
      visible: _vm.visible,
      width: 1200,
      footer: null
    },
    on: {
      cancel: _vm.close
    }
  }, [_c("a-spin", {
    attrs: {
      indicator: _vm.indicator,
      spinning: _vm.spinning
    }
  }, [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("产品信息")))])]), _c("a-form-model", {
    ref: "formRef",
    attrs: {
      model: _vm.form,
      rules: _vm.topRules,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 8
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品名称"),
      prop: "insuranceId"
    }
  }, [_c("a-select", {
    attrs: {
      disabled: "",
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: _vm.changeInsuranceId
    },
    model: {
      value: _vm.form.insuranceId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "insuranceId", $$v);
      },
      expression: "form.insuranceId"
    }
  }, _vm._l(_vm.insuranceList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.insuranceCustomerId
      }
    }, [_vm._v(" " + _vm._s(item.customerInsuranceName) + " ")]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保险方案"),
      prop: "planId"
    }
  }, [_c("a-select", {
    attrs: {
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: function ($event) {
        return _vm.changePlan(true);
      }
    },
    model: {
      value: _vm.form.planId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "planId", $$v);
      },
      expression: "form.planId"
    }
  }, _vm._l(_vm.planList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name) + "-" + _vm._s(_vm.$t("保障额度")) + _vm._s(item.amount) + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId))))]);
  }), 1), _c("span", {
    staticClass: "explanation",
    class: _vm.form.insuranceId ? "" : "explanation-disabled",
    on: {
      click: function ($event) {
        _vm.explanationVisible = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("方案说明")))])], 1), _vm.isAreaPrice ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("地区"),
      prop: "areaCodeValue"
    }
  }, [_c("a-input-group", {
    attrs: {
      compact: ""
    }
  }, [_c("a-cascader", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      options: _vm.rearOptions,
      placeholder: _vm.$t("请选择"),
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: _vm.areaChange
    },
    model: {
      value: _vm.form.areaCodeValue,
      callback: function ($$v) {
        _vm.$set(_vm.form, "areaCodeValue", $$v);
      },
      expression: "form.areaCodeValue"
    }
  })], 1)], 1) : _vm._e(), _vm.hasAttachInfo ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("附加险"),
      prop: "add"
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      allowClear: false,
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: _vm.changeAdditional
    },
    model: {
      value: _vm.form.attachValue,
      callback: function ($$v) {
        _vm.$set(_vm.form, "attachValue", $$v);
      },
      expression: "form.attachValue"
    }
  }, _vm._l(_vm.attachOptions, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        disabled: item.disabled,
        value: item.attachId
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1), _vm.form.attachValue.length ? _c("a-table", {
    staticClass: "marginT20 no-error",
    staticStyle: {
      width: "160%"
    },
    attrs: {
      size: "small",
      bordered: "",
      columns: _vm.columns,
      pagination: false,
      "data-source": _vm.tableData,
      rowKey: "id",
      tableLayout: "fixed"
    },
    scopedSlots: _vm._u([{
      key: "amount",
      fn: function (text, record) {
        return [!record.attachPlan || record.attachPlan && record.attachPlan.length <= 1 ? _c("span", [_vm._v(_vm._s(text))]) : _c("a-select", {
          staticStyle: {
            width: "100%"
          },
          attrs: {
            placeholder: _vm.$t("请选择"),
            allowClear: false,
            getPopupContainer: triggerNode => triggerNode.parentNode
          },
          on: {
            select: e => _vm.amountSelect(e, record)
          },
          model: {
            value: record.attachPlanId,
            callback: function ($$v) {
              _vm.$set(record, "attachPlanId", $$v);
            },
            expression: "record.attachPlanId"
          }
        }, _vm._l(record.attachPlan, function (item, index) {
          return _c("a-select-option", {
            key: index,
            attrs: {
              value: item.id
            }
          }, [_vm._v(_vm._s(item.amount))]);
        }), 1)];
      }
    }], null, false, 3128787537)
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0) : _vm._e(), _vm.form.attachValue.length ? _c("span", {
    staticStyle: {
      "font-size": "14px",
      color: "#1890ff"
    }
  }, [_vm._v(_vm._s(_vm.$t("说明：已自动选中必购附加险，不可取消")))]) : _vm._e()], 1) : _vm._e()], 1), _vm.form.planId ? _c("info-form", {
    attrs: {
      templateData: _vm.template,
      formResult: _vm.formResult,
      checkFieldData: _vm.checkFieldData
    },
    on: {
      updateForm: _vm.onUpdateForm,
      validate: _vm.validate
    }
  }) : _vm._e(), _c("div", {
    staticClass: "bottom-btn"
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onSave
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))])], 1), _c("plan-explanation", {
    attrs: {
      visible: _vm.explanationVisible,
      data: _vm.planList
    },
    on: {
      cancel: function ($event) {
        _vm.explanationVisible = false;
      }
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };